import { render, staticRenderFns } from "./EditBrandTokenForm.vue?vue&type=template&id=f89c6288&scoped=true&"
import script from "./EditBrandTokenForm.vue?vue&type=script&lang=js&"
export * from "./EditBrandTokenForm.vue?vue&type=script&lang=js&"
import style0 from "./EditBrandTokenForm.vue?vue&type=style&index=0&id=f89c6288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89c6288",
  null
  
)

export default component.exports